module.exports = __webpack_public_path__ + "media/images/lb/431-978380651ed293748086631d6be9f2e6.svg";